import type { GridConfig } from "@/types/grid";
import type { BulkImportPageSetupStatic } from "@/types/bulk-import";

export type GlobalTaskType = "before" | "after";

export const getGlobalTasksPageConfig = (
  globalTaskType: GlobalTaskType,
): BulkImportPageSetupStatic<GlobalTaskSchema> => {
  const taskTypeName = $ck._.capitalize(globalTaskType);
  return {
    id: `global-${globalTaskType}-tasks`,
    pageTitle: `cksetup.imports.global-tasks.pageTitle${taskTypeName}`,
    pageHeading: `cksetup.imports.global-tasks.heading${taskTypeName}`,
    learnMoreTitle: "cksetup.imports.global-tasks.learnMoreTitle",
    learnMoreText: "cksetup.imports.global-tasks.learnMoreText",
    templateFileName: `cksetup.imports.global-tasks.templateName${taskTypeName}`,
    templateWorksheetName: `tableColumns.globalTasks.${taskTypeName.toLocaleLowerCase()}WorksheetName`,
    tabTitle: `cksetup.imports.bulk.global${taskTypeName}TasksHeading`,
    tabDescription: `cksetup.imports.bulk.global${taskTypeName}TasksDescription`,
    imageSrc: "/static/images/bulk/daily-duties.png",
    validationSchema: globalTaskSchema,
    addButtonLabel: `cksetup.imports.global-tasks.addNewGlobal${taskTypeName}TaskLine`,
  };
};

export const getGlobalTasksGridConfig = async (): Promise<
  GridConfig<GlobalTaskSchema>
> => {
  return {
    defaultRowData: {
      descriptionBilingual: "",
      showCompleted: true,
    },
    columns: [
      {
        field: "sequence",
        hidden: true,
        isKey: true,
        propagateErrorsTo: "description",
      },
      {
        field: "description",
        title: "tableColumns.globalTasks.description",
        helperText: "tableColumns.globalTasks.descriptionHelperText",
        editor: "text",
        placeholder: "tableColumns.globalTasks.descriptionPlaceholder",
        minWidthPx: 200,
      },
      {
        field: "descriptionBilingual",
        title: "tableColumns.globalTasks.descriptionBilingual",
        helperText: "tableColumns.globalTasks.descriptionBilingualHelperText",
        editor: "text",
        placeholder: "tableColumns.globalTasks.descriptionBilingualPlaceholder",
        minWidthPx: 200,
        required: false,
      },
      {
        field: "showCompleted",
        title: "tableColumns.showCompleted",
        helperText: "tableColumns.globalTasks.showCompletedHelperText",
        editor: "boolean",
        minWidthPx: 200,
      },
      {
        field: "showForEquipment",
        title: "tableColumns.globalTasks.showForEquipment",
        helperText: "tableColumns.globalTasks.showForEquipmentHelperText",
        editor: "boolean",
        minWidthPx: 200,
      },
      {
        field: "showForNonEquipment",
        title: "tableColumns.globalTasks.showForNonEquipment",
        helperText: "tableColumns.globalTasks.showForNonEquipmentHelperText",
        editor: "boolean",
        minWidthPx: 200,
      },
    ],
  };
};
